export default __webpack_public_path__ + "static/dental-chews_mobile-632f0e10178e712257385d8f8c09e1df.jpg";